<!-- review-popup.component.html -->
<div class="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50">
  @if(isLoading){
    <app-loader></app-loader>
  }
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
    <!-- Header -->
    <div class="sticky rounded-xl top-0 bg-white px-4 py-1 flex items-center justify-between">
      <h2 class="text-xl font-bold text-slate-900">Write a review</h2>
      <button (click)="onClose()" class="text-slate-400 hover:text-slate-600 transition-colors">
        ✕
      </button>
    </div>

    <form (ngSubmit)="handleSubmit()" class="p-4 space-y-2">
      <!-- Business Card -->
      <div class="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-2 border border-amber-200">
        <div class="flex gap-3">
          <div class="w-12 h-8 bg-amber-200 rounded-lg flex items-center justify-center">
            <span class="text-xl">🏢</span>
          </div>
          <div>
            <h3 class="font-semibold text-slate-900">Soho Studio Plus</h3>
            <p class="text-sm text-slate-600">Delphin's Barn Street, Dublin</p>
          </div>
        </div>
      </div>

      <!-- Star Rating -->
      <div>
        <label class="block text-sm font-semibold text-slate-900 mb-1">Your rating</label>
        <div class="flex gap-2">
          <button
            *ngFor="let star of stars"
            type="button"
            (click)="setRating(star)"
            (mouseenter)="setHoverRating(star)"
            (mouseleave)="setHoverRating(0)"
            class="transition-transform hover:scale-110"
          >
            <span
              [ngClass]="
                star <= (hoverRating || rating)
                  ? 'text-amber-400'
                  : 'text-slate-300'
              "
              class="text-2xl"
            >
              ★
            </span>
          </button>
        </div>
      </div>

      <!-- Description -->
      <div>
        <label class="block text-sm font-semibold text-slate-900 mb-1">Let us know your experience</label>
        <textarea
          [(ngModel)]="description"
          name="description"
          placeholder="Write your review here"
          class="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent resize-none"
          rows="4"
        ></textarea>
      </div>

      <!-- Image Upload -->
      <div>
        <label class="block text-sm font-semibold text-slate-900 mb-1">
          Share your photos about this salon
        </label>

        <div
          class="border-2 border-dashed border-slate-300 rounded-lg p-4 text-center hover:border-amber-400 hover:bg-amber-50 transition-colors cursor-pointer"
          (click)="fileInput.click()"
          (dragover)="handleDragOver($event)"
          (drop)="handleDrop($event)"
        >
          <p class="text-3xl text-slate-400 mb-1">📁</p>
          <p class="text-sm font-medium text-slate-900">Click to upload or drag and drop</p>
          <p class="text-xs text-slate-500 mt-1">SVG, PNG, JPG or GIF (max 5MB)</p>
          <input
            #fileInput
            type="file"
            multiple
            accept="image/*"
            (change)="handleFileSelect($event)"
            class="hidden"
          />
        </div>

        <!-- Preview Images -->
        <div *ngIf="previewUrls.length > 0" class="mt-2 grid grid-cols-3 gap-3 h-28 max-h-34 overflow-y-auto">
          <div
            *ngFor="let url of previewUrls; let i = index"
            class="relative group"
          >
            <img [src]="url" alt="Preview" class="w-full h-22 object-cover rounded-lg" />
            <button
              type="button"
              (click)="removeImage(i)"
              class="absolute w-5 h-5 flex justify-center items-center p-1 top-1 right-1 bg-black text-white rounded-full text-center opacity-0 group-hover:opacity-100 transition-opacity"
            >
              ✕
            </button>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="footer flex gap-3 pt-2">
        <button
          type="button"
          (click)="onClose()"
          class="flex-1 px-4 py-1 border border-slate-300 text-slate-900 font-semibold rounded-lg hover:bg-slate-50 transition-colors"
        >
          Back
        </button>

        <button
          type="submit"
          [disabled]="isLoading || rating === 0"
          class="flex-1 px-4 py-3 bg-slate-900 text-white font-semibold rounded-lg hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <span *ngIf="isLoading; else submiting">Submitting...</span>
          <ng-template #submiting>Submit</ng-template>
        </button>
      </div>
    </form>
  </div>
</div>
